import { Plan, SubscriptionPlanDTO, useI18n } from '@springbig/shared';
import { Box, VStack, HStack } from 'native-base';
import { Caption, H4 } from '~/shared/Typography';
import React from 'react';
import { useGeneralStyles } from '~/shared/styles';

type PlanBenefitsProps = {
    plan: Plan | SubscriptionPlanDTO;
    alignItems?: 'flex-start' | 'center' | 'flex-end';
};

const PlanBenefits = ({ plan, alignItems = 'flex-start' }: PlanBenefitsProps) => {

    const gStyles = useGeneralStyles();
    const { t } = useI18n();

    return (
        <Box flex={1} alignItems={alignItems}>
            <H4>{ t('subscriptions.benefits') }</H4>
            <VStack space={1} mx={alignItems === 'center' ? 'auto' : null}>
                { plan.human_readable_rewards.map((reward, index) => {

                    return (
                        <HStack key={index} space={2}>
                            <Box
                                borderRadius={'100%'}
                                w={2}
                                h={2}
                                backgroundColor={gStyles.button_background}
                                marginTop={1.5}
                                alignSelf={'flex-start'}
                            />
                            <Caption>
                                <Caption
                                    mr={2}
                                    style={{ textDecorationLine: plan.benefits[index]?.used ? 'line-through' : 'none' }}
                                >
                                    { reward }
                                </Caption>
                                { !!plan.benefits[index]?.used &&
                                    <Caption
                                        fontSize={10}
                                        color={gStyles.button_background}
                                        style={{ textDecorationLine: 'none' }}
                                    >
                                        { t('subscriptions.previously_used') }
                                    </Caption>
                                }
                            </Caption>
                        </HStack>
                    );
                })}
            </VStack>
        </Box>
    );
};

export default PlanBenefits;
